import { render, staticRenderFns } from "./CheckoutContainer.vue?vue&type=template&id=8f7fdf4c&scoped=true"
import script from "./CheckoutContainer.vue?vue&type=script&lang=js"
export * from "./CheckoutContainer.vue?vue&type=script&lang=js"
import style0 from "./CheckoutContainer.vue?vue&type=style&index=0&id=8f7fdf4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7fdf4c",
  null
  
)

export default component.exports